'use strict';

let StorageObj: Storage = {
  local: false,
  session: false,

  check: function(key){
    var storage = window[key+'Storage'];
    try {
      storage.setItem('test', 'test');
      storage.removeItem('test');
      return true;
    } catch (e) {
      return false;
    }
  },
  init: function(){
    console.log('storage.init()');
    this.local = this.check('local');
    this.session = this.check('session');
    return this;
  }
};

const storage = StorageObj.init();

interface Storage {
  check: (key: string) => boolean;
  init: () => Storage;
  local: boolean;
  session: boolean;
}

export default storage;
